import PointerInteraction from 'ol/interaction/Pointer';
import MapBrowserEventType from 'ol/MapBrowserEventType';
import EventType from 'ol/events/EventType';

import { GazetteerEvent } from './gazetteer-event';

export class GazetteerInteraction extends PointerInteraction {

  constructor (map, { layerFilter } = {}) {
    super({ map, handleEvent: event => this._handleEvent(event) });
    this._map = map;
    this._layerFilter = layerFilter;
    this._selectedFeature = null;
  }

  setActive (active) {
    super.setActive(active);
    if (!active) {
      this.dispatchEvent(new GazetteerEvent('gazetteer.clearFlyoutHandler', null));
    }
  }

  /**
   * Handles the map browser event and highlights gazetteer features on hover and selects them on pointerdown.
   *
   * @param {MapBrowserEvent} mapBrowserEvent - Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */
  _handleEvent (mapBrowserEvent) {
    // After pointerdown was handled by the gazetteer interaction, pointerup and click should also stop event propagation to prevent other active interactions from handling that event.
    // Gazetteer interaction should react already on pointerdown, because gazetteer jquery ui autocomplete closes its menu on pointerdown and gazetteer features are cleaned up.
    if (this._discardNextClickEvent && (mapBrowserEvent.type === MapBrowserEventType.POINTERUP || mapBrowserEvent.type === MapBrowserEventType.CLICK)) {
      return false; // stop event propagation
    }
    if (this._discardNextClickEvent && (mapBrowserEvent.type === MapBrowserEventType.SINGLECLICK || mapBrowserEvent.type === MapBrowserEventType.DBLCLICK)) {
      this._discardNextClickEvent = false;
      return false; // stop event propagation
    }

    if (mapBrowserEvent.type === MapBrowserEventType.POINTERDOWN) {
      const gazetteerFeatureUnderMouse = this._getFirstGazetteerFeatureAtPixel(mapBrowserEvent.pixel);
      if (gazetteerFeatureUnderMouse) {
        this._discardNextClickEvent = true;
        const event = new GazetteerEvent('gazetteer.click', gazetteerFeatureUnderMouse);
        this.dispatchEvent(event);
        return false; // stop event propagation
      } else {
        this.dispatchEvent(new GazetteerEvent('gazetteer.closeFlyout', null));
      }
    }

    if (mapBrowserEvent.type === EventType.WHEEL) {
      this.dispatchEvent(new GazetteerEvent('gazetteer.closeFlyout', null));
    }

    if (mapBrowserEvent.type === MapBrowserEventType.POINTERMOVE) {
      const gazetteerFeatureUnderMouse = this._getFirstGazetteerFeatureAtPixel(mapBrowserEvent.pixel);
      if (gazetteerFeatureUnderMouse) {
        if (!this._selectedFeature || this._selectedFeature !== gazetteerFeatureUnderMouse) {
          this._selectedFeature = gazetteerFeatureUnderMouse;
          const event = new GazetteerEvent('gazetteer.hover', gazetteerFeatureUnderMouse);
          this.dispatchEvent(event);
          return false; // stop event propagation
        }
      } else if (this._selectedFeature) {
        this._selectedFeature = null;
      }
    }

    return super.handleEvent(mapBrowserEvent);
  }

  _getFirstGazetteerFeatureAtPixel (pixel) {
    return this._map.getFeaturesAtPixel(pixel, { layerFilter: this._layerFilter })[0] || null;
  }

}
